// Pure helpers for optional wildcard matching. See docs/wildcard-optionality.md.
// Kept dependency-free so wildcard.test.mjs can run them under plain node.

const HELPER_TRAITS = ['wildcard', 'any species'];
const ANY_TRAIT_PHRASES = ['any traits', 'at least one trait', 'a trait', 'any trait'];

// Which traits does an effect actually name?
//   false     -> any trait will do ('shares a trait with')
//   [..]      -> only these traits count
//   'unknown' -> a shape we don't handle; callers keep the old behaviour rather
//                than silently dropping a match
export function namedTraits(traits){
    if(!traits) return false;
    if(ANY_TRAIT_PHRASES.includes(traits)) return false;
    let named = traits.types || traits;
    if(typeof named != 'string' && !Array.isArray(named)) return 'unknown';
    named = (Array.isArray(named) ? named : [named]).flat(2).filter(t => typeof t == 'string');
    if(named.length == 0) return 'unknown';
    return named;
}

// The concrete traits a free slot could be committed to so that it matches the
// other side. Helper traits are never a valid commitment - a slot always becomes
// a specific trait.
export function pickWCCandidates(otherTraitLists, allTraits, traits = false, except = false){
    let named = namedTraits(traits);
    if(named == 'unknown') return [];
    let exclude = except ? (Array.isArray(except) ? except : [except]) : [];
    let out = [];
    for(let list of otherTraitLists || []){
        for(let t of list || []){
            if(typeof t != 'string') continue;
            if(HELPER_TRAITS.includes(t) || t.startsWith('any species')) continue;
            if(!allTraits.includes(t)) continue;
            if(exclude.includes(t)) continue;
            if(named && !named.includes(t)) continue;
            if(!out.includes(t)) out.push(t);
        }
    }
    return out;
}
